import { Grid, Link } from "@mui/material";
import React from "react";
import { BodyTypography, HeaderTypography } from "./Typography";
const Disclaimer = () => {
  return (
    <Grid container flexDirection="column" alignItems="flex-start">
      <HeaderTypography>Haftungsausschluss</HeaderTypography>
      <BodyTypography>
        Die TÜV Rheinland Consulting GmbH ist um Richtigkeit und Aktualität der
        auf dieser Internetpräsenz bereitgestellten Informationen bemüht.
        Trotzdem können Fehler und Unklarheiten nicht vollständig ausgeschlossen
        werden. Die TÜV Rheinland Consulting GmbH übernimmt daher keine Gewähr
        für die Aktualität, Korrektheit, Vollständigkeit und Qualität der
        bereitgestellten Informationen.
      </BodyTypography>
      <BodyTypography></BodyTypography>
      <BodyTypography>
        Die Inhalte fremder Seiten, auf die die TÜV Rheinland Consulting GmbH
        mit Links hinweist, spiegeln nicht die Meinung der TÜV Rheinland
        Consulting GmbH wider, sondern dienen lediglich der Information und der
        Darstellung von Zusammenhängen. Die TÜV Rheinland Consulting GmbH haftet
        nicht für fremde Inhalte, Werbung, Produkte oder andere Materialien, auf
        die sie lediglich im oben genannten Sinne hinweist. Die
        Verantwortlichkeit liegt alleine bei dem Anbieter der Inhalte. Diese
        fremden Inhalte stammen weder von der TÜV Rheinland Consulting GmbH,
        noch hat sie die Möglichkeit, den Inhalt von Seiten Dritter zu
        beeinflussen.
      </BodyTypography>
      <HeaderTypography>Streitschlichtung</HeaderTypography>
      <BodyTypography>
        Die EU-Kommission hat eine Plattform zur Online-Streitbeilegung
        bereitgestellt. Diese Plattform ist unter folgendem Link erreichbar:{" "}
        <Link href="ec.europa.eu/consumers/odr/">
          ec.europa.eu/consumers/odr/
        </Link>{" "}
      </BodyTypography>
      <HeaderTypography>Urheberrecht</HeaderTypography>
      <BodyTypography>
        Sämtliche Texte, Grafiken und Bilder sind urheberrechtlich geschützt;
        eine Verwendung ist nur mit ausdrücklicher Genehmigung zulässig.
        Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten
        Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten
        wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
        Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
      </BodyTypography>
      <HeaderTypography>Bildnachweise</HeaderTypography>
    </Grid>
  );
};

export default Disclaimer;
